import { constants } from '@skyscanner-internal/landing-pages-shared-constants/constants';

import type {
  PageTypeOptions,
  TrackingContext,
} from '@skyscanner-internal/landing-pages-shared-types/types-shared/DealsEvolved';

type CommonTrackingProps = {
  destination?: {
    ['location_attribute']: {
      ['location_attribute_encoding']: string;
      ['location_id']: string;
    };
  };
  ['airline_id']?: string;
  ['common_properties']?: {
    ['culture_settings']: {
      country: string;
      currency: string;
      locale: string;
    };
    ['page_type']: string;
    ['page_variant']?: string;
    platform: string;
  };
  origin?: {
    ['location_attribute']: {
      ['location_attribute_encoding']: string;
      ['location_id']: string;
    };
  };
};

const getDealsCommonTrackingProps = (props: {
  pageTypeOptions: PageTypeOptions;
  trackingContext: TrackingContext;
}): CommonTrackingProps => {
  const extraProps: CommonTrackingProps = {};
  if (props.pageTypeOptions.destinationId) {
    extraProps.destination = {
      location_attribute: {
        location_attribute_encoding: constants.locationAttributeEncoding,
        location_id: props.pageTypeOptions.destinationId,
      },
    };
  }
  if (props.pageTypeOptions.includeCarrier) {
    extraProps.airline_id = props.pageTypeOptions.includeCarrier;
  }

  return {
    common_properties: {
      culture_settings: {
        country: props.trackingContext.market,
        currency: props.trackingContext.currency,
        locale: props.trackingContext.locale,
      },
      page_type: constants[props.trackingContext.pageType],
      page_variant: props.trackingContext.pageVariant,
      platform: props.trackingContext.deviceType || constants.UNSET_PLATFORM,
    },
    origin: {
      location_attribute: {
        location_attribute_encoding: constants.locationAttributeEncoding,
        location_id: props.trackingContext.originCode,
      },
    },
    ...extraProps,
  };
};

export default getDealsCommonTrackingProps;
